/* tslint:disable */
/* eslint-disable */
/**
 * Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    LearningCompetenceTypeEnum,
    LearningCompetenceTypeEnumFromJSON,
    LearningCompetenceTypeEnumFromJSONTyped,
    LearningCompetenceTypeEnumToJSON,
} from './LearningCompetenceTypeEnum';

/**
 * 
 * @export
 * @interface AssociatedResultTemplateDTO
 */
export interface AssociatedResultTemplateDTO {
    /**
     * 
     * @type {string}
     * @memberof AssociatedResultTemplateDTO
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof AssociatedResultTemplateDTO
     */
    competenceTemplateId?: string;
    /**
     * 
     * @type {string}
     * @memberof AssociatedResultTemplateDTO
     */
    description?: string | null;
    /**
     * 
     * @type {LearningCompetenceTypeEnum}
     * @memberof AssociatedResultTemplateDTO
     */
    type?: LearningCompetenceTypeEnum;
}

export function AssociatedResultTemplateDTOFromJSON(json: any): AssociatedResultTemplateDTO {
    return AssociatedResultTemplateDTOFromJSONTyped(json, false);
}

export function AssociatedResultTemplateDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssociatedResultTemplateDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'competenceTemplateId': !exists(json, 'competenceTemplateId') ? undefined : json['competenceTemplateId'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'type': !exists(json, 'type') ? undefined : LearningCompetenceTypeEnumFromJSON(json['type']),
    };
}

export function AssociatedResultTemplateDTOToJSON(value?: AssociatedResultTemplateDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'competenceTemplateId': value.competenceTemplateId,
        'description': value.description,
        'type': LearningCompetenceTypeEnumToJSON(value.type),
    };
}

